import React from 'react';
import {BrowserRouter as Router, Route,Routes} from 'react-router-dom';
import DetailArticle from '../components/DetailArticle';

function RouterDom(){
  return(
    <Router basename={'/'}>
      <Routes>
        <Route index element ={<DetailArticle />} />
        <Route path={`/:id`} element={<DetailArticle />} />
      </Routes>
    </Router>
  )
}

export default RouterDom;
